import { END_POINTS } from "@/constants/url";
import emptySplitApi from "@/lib/rtk";
import { CommonResponseType, Address, AddressFormData } from "@/types/General";

export const AddressService = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get address list
    getAddressList: builder.query<
      CommonResponseType & { data: Address[] },
      void
    >({
      query: () => ({
        url: `${END_POINTS.addressList}`,
        method: "GET",
      }),
      providesTags: ["ADDRESS"],
    }),

    // Create new address
    createAddress: builder.mutation<
      CommonResponseType & { data: Address },
      { body: AddressFormData }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.addressCreate}`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["ADDRESS"],
    }),

    // Edit existing address
    editAddress: builder.mutation<
      CommonResponseType & { data: Address },
      { id: number; body: AddressFormData }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.addressEdit}/${id}`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["ADDRESS"],
    }),

    // Delete address
    deleteAddress: builder.mutation<
      CommonResponseType,
      { id: number }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.addressDelete}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ADDRESS"],
    }),
  }),
});

export const {
  useGetAddressListQuery,
  useLazyGetAddressListQuery,
  useCreateAddressMutation,
  useEditAddressMutation,
  useDeleteAddressMutation,
} = AddressService;

